import { type SchedulingPageStatus } from '../useSchedulingPageStatus'

export enum OnboardingStep {
  CALENDAR = 'calendar',
  MEETING_PLATFORM = 'meeting_platform',
  EVENT_TYPES = 'event_types',
}

export const ONBOARDING_STEP_ORDER: OnboardingStep[] = [OnboardingStep.CALENDAR, OnboardingStep.MEETING_PLATFORM, OnboardingStep.EVENT_TYPES]

export const ONBOARDING_STEP_LABEL: Record<OnboardingStep, string> = {
  [OnboardingStep.CALENDAR]: 'Calendar',
  [OnboardingStep.MEETING_PLATFORM]: 'Meeting platform',
  [OnboardingStep.EVENT_TYPES]: 'Event types',
}

const STEP_BY_STATUS_KIND: Partial<Record<SchedulingPageStatus['kind'], OnboardingStep>> = {
  'connect-calendar': OnboardingStep.CALENDAR,
  'select-calendar': OnboardingStep.CALENDAR,
  'reconnect-calendar': OnboardingStep.CALENDAR,
  'select-meeting-platform': OnboardingStep.MEETING_PLATFORM,
  'no-account-event-types': OnboardingStep.EVENT_TYPES,
  'no-user-page-event-types': OnboardingStep.EVENT_TYPES,
}

export const stepForStatus = (status: SchedulingPageStatus): OnboardingStep | null => STEP_BY_STATUS_KIND[status.kind] ?? null
